import React from 'react';
import ReactDOM from 'react-dom';
//import App from './App';
import 'react-notifications/lib/notifications.css';
import Routes from './routes'

ReactDOM.render(
  <Routes />,
  document.getElementById('root')
);
